/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeHealthStatusResponse
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type healthGetResponse200 = {
  data: ApiEnvelopeHealthStatusResponse
  status: 200
}

export type healthGetResponseSuccess = (healthGetResponse200) & {
  headers: Headers;
};
;

export type healthGetResponse = (healthGetResponseSuccess)

export const getHealthGetUrl = () => {




  return `/api/health`
}

export const useHealthGetHook = (): ( options?: RequestInit) => Promise<healthGetResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getHealthGetUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


